import { render, staticRenderFns } from "./academic.vue?vue&type=template&id=04c87cfa&scoped=true&"
import script from "./academic.vue?vue&type=script&lang=js&"
export * from "./academic.vue?vue&type=script&lang=js&"
import style0 from "./academic.vue?vue&type=style&index=0&id=04c87cfa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c87cfa",
  null
  
)

export default component.exports